export enum GTMEventNames {
  ASSEMBLY_CREATED = 'assembly_created',
  ASSEMBLY_REPLACE_COMPONENT = 'assembly_replace_component',
  ASSEMBLY_SAVED_READY_TO_USE = 'assembly_saved_readytouse',
  ASSEMBLY_EDIT_FROMINFO = 'assembly_edit_frominfo',
  ASSEMBLY_EDIT_FROMCARD = 'assembly_edit_fromcard',
  ASSEMBLY_SAVED_DRAFT = 'assembly_saved_draft',
  ASSEMBLY_DUPLICATED = 'assembly_duplicated_fromcard',
  COMPONENT_CREATED = 'component_created',
  COMPONENT_SAVED_DRAFT = 'component_saved_draft',
  COMPONENT_SAVED_READY_TO_USE = 'component_saved_readytouse',
  LOCATION_GROUP_SCHEDULE_ASSEMBLY = 'location_group_schedule_assembly',
  LOCATION_SCHEDULE_ASSEMBLY = 'location_schedule_assembly',
  COMPONENT_EDIT_FROM_CARD = 'component_edit_fromcard',
  COMPONENT_CONVERT_TO_DRAFT_FROM_CARD = 'component_converttodraft_fromcard',
  COMPONENT_CONVERT_TO_DRAFT_FROM_INFO = 'component_converttodraft_frominfo',
  ENTER_EDIT_COMPONENT_FROM_INFO = 'component_edit_frominfo',
  LOCATION_GROUP_DELETE_ASSEMBLY = 'location_group_delete_assembly',
  LOCATION_DELETE_ASSEMBLY = 'location_delete_assembly',
  ASSEMBLY_ADD_COMPONENT = 'assembly_add_component',
  LOCATION_GROUP_CREATED = 'location_group_created',
  LOCATION_GROUP_EDIT_TIMINGS = 'location_group_edit_timings',
  LOCATION_EDIT_TIMINGS = 'location_edit_timings',
  LOCATION_GROUP_ASSIGN_LOCATION = 'location_group_assign_location',
  COMPONENT_DUPLICATED_FROMCARD = 'component_duplicated_fromcard',
  SCHEDULE_COMPONENT_DELETE = 'schedule_component_delete',
  // OO GTM Events
  OO_LOCATION_TAG_REMOVED_LOCATION = 'oo_location_tag_removed_location',
  OO_LOCATION_EDIT_TIMINGS = 'oo_location_edit_timings',
  OO_OVERRIDE_DELETE = 'oo_override_delete',
  OO_ASSIGN_TAG_TO_LOCATION = 'oo_location_tag_assigned_location',
  OO_OVERRIDE = 'oo_override',
  OO_NEW_LOCATION_TAG_CREATED = 'oo_location_tag_created',
}
